import React from "react";

function Row({ label, val, negative = false }) {
  return (
    <div className="flex items-center justify-between">
      <span className="text-slate-500">{label}</span>
      <span className={`font-mono ${negative ? "text-rose-600" : "text-slate-700"}`}>
        {negative && val && val !== "0" ? `-${val}` : val}
      </span>
    </div>
  );
}

export default function ResiduiCard({ data, nome, admin, onManageAdjustments }) {
  const pctFerie =
    data.giorni_ferie_annuali > 0
      ? Math.round(((data.giorni_ferie_usati || 0) / data.giorni_ferie_annuali) * 100)
      : 0;
  const pctPerm =
    data.ore_permesso_annuali > 0
      ? Math.round(((data.ore_permesso_usate || 0) / data.ore_permesso_annuali) * 100)
      : 0;
  const fmt = (v) => (typeof v === "number" ? v.toFixed(2).replace(/\.?0+$/, "") : v);
  return (
    <div
      className="bg-white border border-slate-200 rounded-md p-4 shadow-sm"
      data-testid={`residui-${data.lavoratore_id}`}
    >
      <div className="flex items-center justify-between gap-2 mb-2">
        <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider truncate">
          {nome} · {data.anno}
          {typeof data.mesi_maturati === "number" && (
            <span className="ml-1 text-[10px] normal-case text-slate-400">
              (matur. mese {data.mesi_maturati}/12)
            </span>
          )}
        </div>
        {admin && (
          <button
            onClick={() => onManageAdjustments && onManageAdjustments(data)}
            data-testid={`btn-manage-adj-${data.lavoratore_id}`}
            className="text-[10px] font-semibold text-blue-700 hover:text-blue-900 hover:underline whitespace-nowrap"
          >
            Modifica saldo
          </button>
        )}
      </div>

      <div className="grid grid-cols-2 gap-3">
        {/* FERIE */}
        <div>
          <div className="text-[10px] text-slate-500 uppercase tracking-wider">Ferie (gg)</div>
          <div className="text-2xl font-black text-slate-900">
            {fmt(data.giorni_ferie_disponibili_ora ?? data.giorni_ferie_residui)}
          </div>
          <div className="text-[10px] text-slate-500">disponibili ora</div>
          <div className="mt-2 space-y-0.5 text-[10px] text-slate-600">
            <Row label="Maturati" val={fmt(data.giorni_ferie_maturati ?? 0)} />
            {(data.giorni_ferie_riporto ?? 0) !== 0 && (
              <Row label="Riporto" val={fmt(data.giorni_ferie_riporto)} />
            )}
            {(data.giorni_ferie_aggiustamenti ?? 0) !== 0 && (
              <Row
                label="Aggiust."
                val={`${data.giorni_ferie_aggiustamenti > 0 ? "+" : ""}${fmt(
                  data.giorni_ferie_aggiustamenti
                )}`}
              />
            )}
            <Row label="Utilizzati" val={fmt(data.giorni_ferie_usati ?? 0)} negative />
          </div>
          <div className="mt-1 h-1 bg-slate-200 rounded overflow-hidden">
            <div className="h-full bg-slate-500" style={{ width: `${pctFerie}%` }} />
          </div>
        </div>

        {/* PERMESSI */}
        <div>
          <div className="text-[10px] text-slate-500 uppercase tracking-wider">Permessi (ore)</div>
          <div className="text-2xl font-black text-slate-900">
            {fmt(data.ore_permesso_disponibili_ora ?? data.ore_permesso_residue)}
          </div>
          <div className="text-[10px] text-slate-500">disponibili ora</div>
          <div className="mt-2 space-y-0.5 text-[10px] text-slate-600">
            <Row label="Maturate" val={fmt(data.ore_permesso_maturate ?? 0)} />
            {(data.ore_permesso_riporto ?? 0) !== 0 && (
              <Row label="Riporto" val={fmt(data.ore_permesso_riporto)} />
            )}
            {(data.ore_permesso_aggiustamenti ?? 0) !== 0 && (
              <Row
                label="Aggiust."
                val={`${data.ore_permesso_aggiustamenti > 0 ? "+" : ""}${fmt(
                  data.ore_permesso_aggiustamenti
                )}`}
              />
            )}
            <Row label="Utilizzate" val={fmt(data.ore_permesso_usate ?? 0)} negative />
          </div>
          <div className="mt-1 h-1 bg-slate-200 rounded overflow-hidden">
            <div className="h-full bg-pink-600" style={{ width: `${pctPerm}%` }} />
          </div>
        </div>
      </div>
    </div>
  );
}
